<template>
  <div>
    <Modal
      title="Bulk Coverage Area Upload"
      :disabled="disabled"
      class-name="small-modal"
      :saving="uploading"
      submit-btn-text="Import"
      @submit="handleUpload"
      @hide-modal="$emit('hide-modal')"
    >
      <div>
        <span
          >Upload the completed template to import coverage area changes</span
        >
        <FileUpload
          :text="fileName"
          outline
          accept=".xls,.xlsx"
          @change="handleSelection"
        />
      </div>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import FileUpload from "@/components/FileUpload.vue";
import Modal from "@/components/Modal.vue";

const store = useStore();

const emit = defineEmits(["hide-modal"]);

const file = ref(null);
const uploading = ref(false);

const fileName = computed(() => {
  if (file.value) return file.value.name;
  return "Browse...";
});

const disabled = computed(() => {
  return !isNaN(file.value);
});

function handleSelection(e) {
  file.value = e.target.files[0];
}

async function uploadCoverageAreas(data) {
  return store.dispatch("uploadCoverageAreas", data);
}

async function handleUpload() {
  try {
    uploading.value = true;
    await uploadCoverageAreas({
      file: file.value
    });
    window.notify.success("Upload started");
    emit("hide-modal");
  } catch (e) {
    window.notify.error(e.message);
  }
  uploading.value = false;
}
</script>
